export default __webpack_public_path__ + "static/media/screen5.658cd82c.png";